import { handleError } from "../Helpers/ErrorHandler";
import {
  CreditQuery,
  CreditStatus,
  CreditSummary,
  Pagination,
  PaymentPlans,
  PaymentPlansDetail,
} from "../Models/Credit";

import axiosInstance from "./Axios";

interface SnoozeFeeResponse {
  dueDate: string;
  snoozeFee: number;
}

export const getPaymentPlans = async (
  paginationParam: Pagination,
  creditQuery: CreditQuery
) => {
  try {
    let statusParam;
    if (creditQuery?.orderDirection?.length === 0) {
      statusParam = "";
    }
    statusParam = creditQuery?.status
      .map((status) => `&status=${status}`)
      .join("");

    const data = await axiosInstance.get<PaymentPlans>(
      `/credits/payment-plans?page=${paginationParam.page}&size=${paginationParam.size}${statusParam}&orderDirection=${creditQuery.orderDirection}&orderBy=dueDate`
    );
    return data.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPaymentPlansDetail = async (id: number) => {
  try {
    const data = await axiosInstance.get<PaymentPlansDetail>(
      `/credits/payment-plans/${id}/details`
    );
    return data.data;
  } catch (error) {
    handleError(error);
  }
};

export const getCreditsSummary = async () => {
  try {
    const data = await axiosInstance.get<CreditSummary>(`/credits/summary`);
    return data.data;
  } catch (error) {
    handleError(error);
  }
};

export const calculateSnoozeFee = async (id: number, days: number): Promise<SnoozeFeeResponse> => {
  try {
    const response = await axiosInstance.post(`/credits/payment-plans/${id}/snooze-preview`, {
      duration: days
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};